import { useState as n, useRef as m, useEffect as d } from "react";
const E = ({ slugs: r, skip: s = !1 }) => {
  const [i, f] = n(/* @__PURE__ */ new Map()), [c, l] = n(!1), [u, o] = n(null), p = m([]);
  return d(() => {
    if (s || ((t, a) => {
      if (t.length !== a.length)
        return !1;
      for (let e = 0; e < t.length; e++)
        if (t[e] !== a[e])
          return !1;
      return !0;
    })(p.current, r))
      return;
    p.current = r;
    const A = async (t) => {
      const a = await fetch(`/api/v4/apps/${encodeURIComponent(t)}`);
      if (!a.ok)
        throw new Error(`Failed to fetch app details for "${t}"`);
      return a.json();
    };
    (async () => {
      l(!0), o(null);
      try {
        const t = Array.from(new Set(r)), a = await Promise.allSettled(t.map(async (e) => {
          const { image: h, name: y } = await A(e);
          return [e, { image: h, name: y }];
        }));
        f(new Map(a.filter((e) => e.status === "fulfilled").map((e) => e.value)));
      } catch (t) {
        o(t);
      } finally {
        l(!1);
      }
    })();
  }, [r, s]), { data: i, isLoading: c, error: u };
};
export {
  E as useAppDetailsBySlugs
};
//# sourceMappingURL=useAppDetailsBySlugs.es.js.map
